/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ContactDto } from './ContactDto';
import {
    ContactDtoFromJSON,
    ContactDtoFromJSONTyped,
    ContactDtoToJSON,
    ContactDtoToJSONTyped,
} from './ContactDto';

/**
 * 
 * @export
 * @interface ContactResponseDto
 */
export interface ContactResponseDto {
    /**
     * Contact information
     * @type {ContactDto}
     * @memberof ContactResponseDto
     */
    contact: ContactDto;
}

/**
 * Check if a given object implements the ContactResponseDto interface.
 */
export function instanceOfContactResponseDto(value: object): value is ContactResponseDto {
    if (!('contact' in value) || value['contact'] === undefined) return false;
    return true;
}

export function ContactResponseDtoFromJSON(json: any): ContactResponseDto {
    return ContactResponseDtoFromJSONTyped(json, false);
}

export function ContactResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'contact': ContactDtoFromJSON(json['contact']),
    };
}

export function ContactResponseDtoToJSON(json: any): ContactResponseDto {
    return ContactResponseDtoToJSONTyped(json, false);
}

export function ContactResponseDtoToJSONTyped(value?: ContactResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contact': ContactDtoToJSON(value['contact']),
    };
}

